import PilotsGallery from './pilots-gallery';

export default PilotsGallery;
